import React from "react";
import ColorSchema from "./color/index.ts";
type size = "small" | "medium" | "large";
type styleButton = "normal" | "outline" | "simple" | "icon";
type typeButton = "default" | "disable";
interface buttonType extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: size;
  color?: string;
  textColor?: string;
  icon?: React.ReactNode;
  styleButton?: styleButton;
  iconPosition?: "left" | "right" | "center";
  paddingX?: number;
  typeButton?: typeButton;
  buttonClassName?: string;
  height?: string;
}
const CustomButton = React.forwardRef<HTMLButtonElement, buttonType>(
  ({
    size = "medium",
    color = ColorSchema.main_color,
    styleButton = "normal",
    textColor = ColorSchema.gray_7,
    children,
    icon,
    iconPosition,
    paddingX = size == "medium" ? "6px" : size == "large" ? "8px" : "4px",
    typeButton = "default",
    buttonClassName = "",
    height = 28,
    style,
    onClick,
    ...props
  }) => {
    const buttonStyle = {
      borderRadius: styleButton != "icon" ? "8px" : "4px",
      paddingTop: size == "medium" ? "6px" : size == "large" ? "8px" : "4px",
      paddingBottom: size == "medium" ? "6px" : size == "large" ? "8px" : "4px",
      paddingRight: paddingX,
      paddingLeft: paddingX,
      backgroundColor:
        styleButton == "outline" ||
        (styleButton == "simple" && color == ColorSchema.main_color)
          ? ColorSchema.background
          : color,
      color: textColor,
      border: styleButton == "outline" ? `1px solid ${color}` : "none",
      width: "100%",

      opacity: typeButton == "disable" ? "50%" : "100%",
      cursor: typeButton == "disable" ? "context-menu" : "pointer",
      fontSize: 16,
    };

    return (
      <button
        style={{ ...buttonStyle, ...style }}
        className={buttonClassName}
        {...props}
        onClick={(event) => {
          if (typeButton != "disable") {
            onClick?.(event);
          }
        }}
      >
        {icon ? (
          iconPosition == "left" ? (
            <div
              className="d-flex  align-items-center justify-content-center"
              style={{ height: height }}
            >
              <span className="me-1">{children}</span>
              {icon}
            </div>
          ) : (
            <div
              className="d-flex  align-items-center justify-content-center"
              style={{ height: height }}
            >
              {icon}
              <span className="ms-1">{children}</span>
            </div>
          )
        ) : (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: styleButton != "icon" ? height : "auto" }}
          >
            {children}
          </div>
        )}
      </button>
    );
  }
);
export default CustomButton;
export type { buttonType };
